import { useEffect } from "react";

import { FiltersContext } from "components/Filters";
import { URL_FILTER_TAB_KEY } from "constants/urlQueryKeys";
import usePrevious from "hooks/usePrevious";
import useTypedContext from "hooks/useTypedContext";
import useURLParams from "hooks/useURLParams";

import useStacksTableSelectionStore from "../Table/useStacksTableSelectionStore";

const StackFiltersLayoutSyncWithPredefinedTabs = () => {
  const urlParams = useURLParams();
  const tab = urlParams.get(URL_FILTER_TAB_KEY);
  const prevTab = usePrevious(tab);

  const clearSelected = useStacksTableSelectionStore((state) => state.clearSelected);

  const { forceReMountSidebar, setActiveFiltersFromInitialParams } =
    useTypedContext(FiltersContext);

  useEffect(() => {
    if (prevTab !== tab) {
      forceReMountSidebar();
      setActiveFiltersFromInitialParams();
      clearSelected();
    }
  }, [prevTab, tab, forceReMountSidebar, setActiveFiltersFromInitialParams, clearSelected]);

  return null;
};

export default StackFiltersLayoutSyncWithPredefinedTabs;
